import { memo } from 'react';
import { GridColumnHeaderParams } from "@mui/x-data-grid";
import { Typography } from "@mui/material";
import TooltipBadge from "@/components/common/TooltipBadge";

interface CustomColumnHeaderProps extends GridColumnHeaderParams {
    tooltip?: string,
    label?: string,
}

const CustomColumnHeader = ({ field, colDef, label, tooltip = '' }: CustomColumnHeaderProps) => {
    const headerName = colDef.headerName;

    return (
        <div>
            <Typography component={'span'} fontWeight={500} variant={'body2'}>
                {label || headerName}
            </Typography>

            {tooltip && (
                <TooltipBadge tooltip={tooltip} IconProps={{
                    sx: {
                        ml: 0.5,
                        opacity: 0.5,
                        fontSize: '16px',
                    }
                }} />
            )}
        </div>
    );
}

export default memo(CustomColumnHeader);